// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ff-9";
export var fulfillmentFormRail = "_ff-8";
export var headerTitleRow = "_ff-b";
export var orderDetailsWrapper = "_ff-6";
export var paymentInformationGrid = "_ff-g";
export var paymentSummaryColumn = "_ff-h";
export var shipmentContainer = "_ff-a";
export var shipmentDetailsMainPane = "_ff-7";
export var shipmentNavigationCard = "_ff-4";
export var shipmentNavigationRail = "_ff-2";
export var shipmentNavigationRailHeader = "_ff-3";
export var shipmentSummaryFact = "_ff-d";
export var shipmentSummaryGrid = "_ff-c";
export var shipmentSummaryMetadataRow = "_ff-e";
export var shipmentSummaryTags = "_ff-f";
export var shipmentWorkspace = "_ff-0";
export var shipmentWorkspaceContent = "_ff-5";
export var shipmentWorkspaceHeader = "_ff-1";